/** DailyFit24 — FI / EN (marketing + verplichte legalteksten) */
export const translations = {
  fi: {
    metaTitle: 'DailyFit24 — Kunto- ja ravitsemuspalvelu',
    navProduct: 'Palvelu',
    navSolution: 'Ratkaisu',
    navPricing: 'Hinta',
    navCta: 'Aloita',
    heroBadge: 'Uusi: elinikäinen portaali pääsy',
    heroTitle: 'Harjoittelu ja ravinto, yksi selkeä kokonaisuus.',
    heroSubtitle:
      'DailyFit24 yhdistää ohjatut treenit, videot ja ravitsemussuunnittelun. Rakennamme rutiinit, jotka sopivat arkeesi — olitpa vasta aloittamassa tai jo kokeneempi.',
    heroCta: 'Aloita muodonmuutoksesi',
    heroSecondary: 'Lue lisää',
    stats: [
      { value: '24/7', label: 'Sisältöä portalissa' },
      { value: '100+', label: 'Harjoitus- ja videoidea' },
      { value: '1×', label: 'Kertamaksu, ei kuukausimaksua' },
    ],
    featuresTitle: 'Mitä saat',
    featuresSubtitle: 'Kaikki keskitettynä yhteen palveluun — ilman turhaa säätöä.',
    features: [
      {
        title: 'Ohjatut harjoitukset',
        body: 'Selkeät sarjat ja videot, joilla etenet askel askeleelta. Sisältö on koottu niin, että näet nopeasti mitä teet seuraavaksi.',
      },
      {
        title: 'Ravitsemuksen tuki',
        body: 'Tasapainoinen ruokailu tukee treeniä. Saat käyttöösi suunnitelman, joka auttaa pitämään energiatason tasaisena.',
      },
      {
        title: 'Joustava käyttö',
        body: 'Käytä palvelua silloin kun sinulle sopii. Yksi maksu avaa pääsyn portaaliin ilman sitovia kuukausisopimuksia.',
      },
    ],
    splitTitle: 'Kenelle DailyFit24 on tehty',
    splitLead:
      'Palvelu sopii sekä aloitteleville että niille, jotka haluavat järjestelmällisemmän tavan seurata kuntoa ja ravintoa. Emme lupaa taikatemppuja — lupaamme selkeän polun ja sisällön, jota on helppo noudattaa.',
    splitPoints: [
      'Selkeä eteneminen ilman arvailua',
      'Yhdistelmä liikuntaa ja ruokailua',
      'Tuki omaan tahtiin, omalla laitteellasi',
    ],
    processTitle: 'Näin pääset alkuun',
    processSteps: [
      {
        step: '01',
        title: 'Aloita',
        body: 'Valitse Aloita muodonmuutoksesi ja seuraa näytöllä näkyviä ohjeita.',
      },
      {
        step: '02',
        title: 'Vahvista',
        body: 'Lähetä viesti DFIT numeroon 173190 matkapuhelimestasi.',
      },
      {
        step: '03',
        title: 'Käytä',
        body: 'Kun tilaus on kunnossa, saat pääsyn portaaliin ja kaikkeen sisältöön.',
      },
    ],
    quote:
      '“Halusimme rakentaa jotain yksinkertaista: yhden paikan, jossa treeni ja ruokailu puhuvat samaa kieltä.”',
    quoteAuthor: 'DailyFit24-tiimi',
    ctaBandTitle: 'Valmis kokeilemaan?',
    ctaBandText:
      'Yksi viesti, yksi maksu — elinikäinen pääsy. Hinta 9,90 € per viesti. Kertamaksullinen palvelu.',
    priceLine:
      'Hinta on 9,90 € per viesti. Tämä on kertamaksullinen palvelu, joka antaa sinulle elinikäisen pääsyn portaaliin.',
    legalLead:
      'DailyFit24 – Käy läpi kaikki huolellisesti valmistellut harjoitukset ja videot fitnessvaikuttajaltamme, ja muuta rutiinejasi askel askeleelta saavuttaaksesi paremman version itsestäsi. Kaikki harjoitukset on valittu tarkasti parhaan mahdollisen tuloksen saavuttamiseksi. DailyFit24 on suunniteltu sekä harrastajille että ammattilaisille. Jokaisen onnistuneen harjoituksen jälkeen tasapainota ravinnon saantisi huolella laaditun ravintosuunnitelmamme avulla. Anna kehollesi paras versio itsestäsi ja pysy aina kunnossa!',
    legalPrice:
      'Hinta on 9,90 € per viesti. Tämä on kertamaksullinen palvelu, joka antaa sinulle elinikäisen pääsyn portaaliin.',
    legalOrder:
      'Tilataksesi palvelun, klikkaa Aloita muodonmuutoksesi -painiketta, minkä jälkeen sinun tulee lähettää viesti DFIT numeroon 173190. Voit ottaa yhteyttä palveluntarjoajaan sähköpostitse osoitteessa dailyfit24.fi@silverlines.info tai soittamalla tukinumeroon 0942451583.',
    legalProvider:
      'Palveluntarjoaja: MBX Productive Ltd, Pimen Zogravski Nr. 14, 1000 Sofia, Bulgaria',
    cta: 'Aloita muodonmuutoksesi',
    terms: 'Käyttöehdot',
    contact: 'Yhteystiedot',
    footerRights: '© DailyFit24. Kaikki oikeudet pidätetään.',
    langFi: 'Suomi',
    langEn: 'English',
  },
  en: {
    metaTitle: 'DailyFit24 — Fitness & nutrition platform',
    navProduct: 'Product',
    navSolution: 'Solution',
    navPricing: 'Pricing',
    navCta: 'Get started',
    heroBadge: 'New: lifetime portal access',
    heroTitle: 'Training and nutrition in one clear system.',
    heroSubtitle:
      'DailyFit24 brings together guided workouts, video content, and meal planning. We help you build routines that fit real life — whether you are just starting out or already training regularly.',
    heroCta: 'Start your transformation',
    heroSecondary: 'Learn more',
    stats: [
      { value: '24/7', label: 'Content in the portal' },
      { value: '100+', label: 'Workout & video ideas' },
      { value: '1×', label: 'One-time fee, no subscription' },
    ],
    featuresTitle: 'What you get',
    featuresSubtitle: 'Everything in one service — without the clutter.',
    features: [
      {
        title: 'Guided workouts',
        body: 'Clear sets and videos so you always know the next step. Content is structured for steady progress.',
      },
      {
        title: 'Nutrition support',
        body: 'Balanced eating backs your training. Our plan helps you keep energy levels steady day to day.',
      },
      {
        title: 'Flexible access',
        body: 'Use the service when it suits you. One payment opens the portal with no monthly lock-in.',
      },
    ],
    splitTitle: 'Who DailyFit24 is for',
    splitLead:
      'Built for beginners and for anyone who wants a more structured way to track fitness and food. We do not promise miracles — we offer a clear path and content that is easy to follow.',
    splitPoints: [
      'Straightforward progression without guesswork',
      'Movement and meals in one place',
      'Go at your own pace on your own device',
    ],
    processTitle: 'How to get started',
    processSteps: [
      {
        step: '01',
        title: 'Start',
        body: 'Tap Start your transformation and follow the on-screen steps.',
      },
      {
        step: '02',
        title: 'Confirm',
        body: 'Send the message DFIT to 173190 from your mobile phone.',
      },
      {
        step: '03',
        title: 'Use',
        body: 'Once your order is complete, you get access to the portal and all content.',
      },
    ],
    quote:
      '“We wanted one simple thing: a single place where training and eating speak the same language.”',
    quoteAuthor: 'The DailyFit24 team',
    ctaBandTitle: 'Ready to try it?',
    ctaBandText:
      'One message, one payment — lifetime access. €9.90 per message. One-time paid service.',
    priceLine:
      'The price is €9.90 per message. This is a one-time paid service that gives you lifetime access to the portal.',
    legalLead:
      'DailyFit24 — Work through carefully prepared workouts and videos from our fitness creator, and start changing your routines step by step. Sessions are chosen for the best results. The service is for hobbyists and professionals. After each workout, balance nutrition with our meal plan. Give your body its best version and stay fit.',
    legalPrice:
      'The price is €9.90 per message. This is a one-time paid service that gives you lifetime access to the portal.',
    legalOrder:
      'To subscribe, tap Start your transformation, then send the message DFIT to 173190. Contact the provider at dailyfit24.fi@silverlines.info or call 0942451583.',
    legalProvider:
      'Service provider: MBX Productive Ltd, Pimen Zogravski Nr. 14, 1000 Sofia, Bulgaria',
    cta: 'Start your transformation',
    terms: 'Terms of use',
    contact: 'Contact',
    footerRights: '© DailyFit24. All rights reserved.',
    langFi: 'Suomi',
    langEn: 'English',
  },
};
